import React, { useEffect } from "react";
import {
  Box,
  TablePagination,
  makeStyles,
  Typography,
  Button,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { NavLink as RouterLink } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import { fillMissingTags } from "src/utils/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(2),
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(2),
  },
  image: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.up("md")]: {
      width: 248,
      height: 128,
    },
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
  gridzerosp: {
    margin: 0,
    padding: 0,
  },
}));

const News = ({
  className,
  globalData,
  news,
  handleOpenDocument,
  handleLimitChange,
  handlePageChange,
  page,
  limit,
  total,
  ...rest
}) => {
  const classes = useStyles();

  useEffect(() => {
    setTimeout(fillMissingTags(), 1000);
    return () => {};
  }, [total]);

  return (
    <Box>
      <Box>
        {news.map((newsItem) => {
          return (
            <Paper className={classes.paper} key={`news-${newsItem.id}`}>
              <Grid container spacing={2}>
                {newsItem.image ? (
                  <Grid item>
                    <Box className={classes.image}>
                      <img
                        className={classes.img}
                        alt={`Zdjęcie do ${newsItem.title}`}
                        src={newsItem.image}
                      />
                    </Box>
                  </Grid>
                ) : (
                  <></>
                )}
                <Grid item xs={12} sm container>
                  <Grid item xs container direction="column" spacing={2}>
                    <Grid item xs>
                      <Typography gutterBottom variant="h4" component="h2">
                        {newsItem.title}
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        {newsItem.header}
                      </Typography>

                      <Grid container>
                        <Grid item xs={6}>
                          
                        </Grid>
                        <Grid item xs={6} align="right">
                          <Button
                            color="primary"
                            className={classes.button}
                            component={RouterLink}
                            to={`/aktualnosci/artykul/${newsItem.id}/${page}/${limit}`}
                          >
                            Czytaj dalej
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          );
        })}
      </Box>
      <Paper className={classes.paper}>
        {total ? (
          <TablePagination
            id="news-paginator"
            label="Stronnicowanie artykułów"
            component="div"
            count={total}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        ) : (
          <Skeleton />
        )}
      </Paper>
    </Box>
  );
};

export default News;
